import React from 'react'

import './no-results-found.scss'

const NoResultsFound = props => {
    return (
        <div className="no-results-found">
            <img src="/vr-icon.png" alt="VR Icon" />
            <h4>No Results Found</h4>
        </div>
    )
}

export default NoResultsFound


// WEBPACK FOOTER //
// ./src/components/main/no-results-found/index.jsx